import React from 'react'
import { FormFieldLayout } from '@/components/Form/FormField'

export const ContentField: React.FC<{
  label: React.ReactNode
  children: React.ReactNode
}> = ({ label, children }) => <FormFieldLayout label={label}>{children}</FormFieldLayout>
